export async function ptlDeleteOrderUseCase(id, shipmentRepository) {
    
    const result = await shipmentRepository.ptl_delete_order(id);
    
    return result;
}